<template>
  <v-container
    fluid
    tag="section"
  >
    <v-card>
      <v-card-text>
        <v-row dense>
          <v-col
            cols="12"
            sm="3"
          >
            <skud-place-select />
          </v-col>
          <v-col
            cols="12"
            sm="9"
            class="d-sm-flex justify-end"
          >
            <v-btn
              icon
              title="Обновить"
              :disabled="!place"
              @click="load()"
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-alert
          v-if="!place"
          type="info"
          outlined
          class="mt-4 mb-0"
        >
          Выберите место
        </v-alert>
        <v-data-table
          v-else
          :headers="headers"
          :items="items"
          :loading="loading"
          :footer-props="datatable_footer"
          no-data-text="Нет данных для отображения"
        >
          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
          </template>
          <template v-slot:item.actions="{item}">
            <skud-actions-menu>
              <v-list-item @click="askDelete(item)">
                <v-list-item-content>
                  Удалить device-id
                </v-list-item-content>
              </v-list-item>
            </skud-actions-menu>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="dialog_delete.show"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Удалить device-id?</span>
        </v-card-title>
        <v-card-text>
          {{ dialog_delete.item ? (dialog_delete.item.name || dialog_delete.item.id) : '' }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            :loading="dialog_delete.loading"
            @click="doDelete()"
          >
            <span class="mx-4">Удалить</span>
          </v-btn>
          <v-btn
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="dialog_delete.show = false"
          >
            <span class="mx-4">Отмена</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import SkudPlaceSelect from '@/views/skud/components/SkudPlaceSelect.vue'
import SkudActionsMenu from '@/views/skud/components/SkudActionsMenu.vue'
import { SkudPointService } from '@/views/skud/shared/services/skud-point-service'

export default {
  name: 'SkudPointList',
  components: {
    SkudPlaceSelect,
    SkudActionsMenu
  },
  data () {
    return {
      svc: null,
      items: [],
      loading: false,
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageOptions: [5, 10, 15, 30, 50]
      },
      headers: [
        { text: 'Действия', value: 'actions', sortable: false },
        { text: 'ID', value: 'id' },
        { text: 'Имя', value: 'name' },
        { text: 'Направление', value: 'direction_text' }
      ],
      dialog_delete: { show: false, loading: false, item: null }
    }
  },
  computed: {
    place () {
      return this.$store.state.skud_place
    }
  },
  watch: {
    place () {
      this.items = []
      if (this.place) this.load()
    }
  },
  mounted () {
    this.svc = new SkudPointService()
    if (this.place) this.load()
  },
  methods: {
    async load () {
      if (!this.place) return
      this.loading = true
      const res = await this.svc.getPoints(this.place)
      this.loading = false
      if (this.svc.error) {
        this.$store.commit('snackbar', this.svc.error)
        return
      }
      this.items = res
    },
    askDelete (item) {
      this.dialog_delete.item = item
      this.dialog_delete.show = true
    },
    async doDelete () {
      this.dialog_delete.loading = true
      const res = await this.svc.deletePointDevice(this.place, this.dialog_delete.item.id)
      this.dialog_delete.loading = false
      if (!res.ok) {
        this.$store.commit('snackbar', res.error || 'Ошибка удаления device-id')
        return
      }
      this.dialog_delete.show = false
      this.$store.commit('snackbar', 'Device-id удалён')
    }
  }
}
</script>
